import { render } from "./FinishedPayment.vue?vue&type=template&id=06ebec1c&lang=pug"
import script from "./FinishedPayment.vue?vue&type=script&lang=js"
export * from "./FinishedPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__